import { useEffect, useRef, useState } from 'react';
import PDFViewer from '../view/PDFViewer';
import { Divider } from 'antd'
import { Outlet, useNavigate, useParams, useSearchParams } from "react-router-dom";
export default function PDFPage() {
    const [search, setSearch] = useSearchParams();
    const [url, setUrl] = useState()
    useEffect(() => {
        let id = search.get("id")
        setUrl(atob(id))
    }, []);

    return (
        <div style={{ height: 'calc(100vh - 70px)' }}>
            {url && <PDFViewer
                url={url}
            />
            }
        </div>

    );
};